import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { CustomerModel } from '../models/customer.model';
import {LoyaltyProgramCardModel} from "@/common/models/loyalty-program-card.model";

export class LoyaltyProgramCardsApiService extends ApiService {
  static endpoint = 'loyalty-program-cards';

  /**
   * @param {Number|null} customerId
   * @return {String}
   * @protected
   */
  static buildLoyaltyProgramCardsUrl(customerId = null) {
    return this.buildUrl(customerId);
  }

  /**
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<LoyaltyProgramCardModel>>}
   * @public
   */
  static async getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildLoyaltyProgramCardsUrl(), {
      ...config,
      dataModel: LoyaltyProgramCardModel,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Number} cardId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<LoyaltyProgramCardModel>>}
   * @public
   */
  static async get(cardId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildLoyaltyProgramCardsUrl(cardId), {
      ...config,
      dataModel: LoyaltyProgramCardModel,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Number} cardId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<LoyaltyProgramCardModel>>}
   * @public
   */
  static async patch(cardId, data, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildLoyaltyProgramCardsUrl(cardId), data, {
      ...config,
      dataModel: LoyaltyProgramCardModel,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
